<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button v-if="hasExport" type="primary" @click="onDownExcel">导出</el-button>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/ingredients/add')">新增</el-button>

      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="materialName" label="材料名称">
           <el-input v-model="searchForm.materialName" clearable placeholder="请输入材料名称" />
<!--          <el-input clearable v-model="specName" @focus="dialogVisible = true" placeholder="品种规格" />-->
        </el-form-item>
        <el-form-item prop="supplierInfo" label="供应商名称">
          <el-select v-model="searchForm.supplierInfo" clearable filterable placeholder="请选择供应商名称">
            <el-option v-for="(item, index) of supplierArr" :value="item.materialsId" :label="item.materialsName"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="entryDate" label="进厂日期">
          <el-date-picker v-model="searchForm.entryDate" placeholder="请选择进厂日期" type="date" clearable format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="productionDate" label="生产日期">
            <el-date-picker v-model="searchForm.productionDate" placeholder="请选择生产日期" type="date" clearable
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item> -->
        <el-form-item prop="plateNumber" label="车牌号">
          <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item prop="createTime" label="创建时间">
          <el-date-picker v-model="dateArr" @change="changeDate" type="datetimerange" range-separator="至"
            start-placeholder="开始时间" end-placeholder="结束时间" clearable format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="材料名称" prop="materialName"></el-table-column>

        <el-table-column min-width="120" label="进场日期" prop="entryDate"></el-table-column>
        <el-table-column min-width="120" label="生产日期" prop="productionDate"></el-table-column>
        <el-table-column min-width="120" label="车牌号" prop="plateNumber">

        </el-table-column>
        <el-table-column min-width="120" label="供应商信息" prop="supplierInfoName">

        </el-table-column>
        <el-table-column min-width="100" label="数量" prop="quantity"></el-table-column>
        <el-table-column min-width="120" label="保质期(月)" prop="qualityGuaranteePeriod"></el-table-column>
        <el-table-column min-width="120" label="罐号" prop="tankNumber"></el-table-column>
        <el-table-column min-width="140" label="供应商地址" prop="supplierAddress"></el-table-column>
        <el-table-column min-width="120" label="联系方式" prop="supplierContactNumber"></el-table-column>
        <el-table-column min-width="120" label="取样日期" prop="sampleDate"></el-table-column>
        <el-table-column min-width="120" label="检测日期" prop="testDate"></el-table-column>
        <el-table-column min-width="160" label="创建人姓名" prop="createUserName"></el-table-column>
        <el-table-column min-width="180" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">

            <el-button type="text" @click="
              $router.push('/ingredients/detail?inspectId=' + row.inspectId)
              ">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/ingredients/edit?inspectId=' + row.inspectId)">编辑</el-button>

            <el-button v-if="hasDel" type="text" @click="deleteRow(row.inspectId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'ingredients',
  mixins: [keepAlive],
  components: {
    SpecChoose
  },
  data() {
    return {
      tableData: [],
      specName: '',
      dialogVisible: false,
      page: 1,
      total: 0,
      loading: false,
      dateArr: [],
      searchForm: {
        entryDate: '',
        productionDate: '',
        plateNumber: '',
        materialName: '',
        supplierInfo: '',
        startTime: '',
        endTime: ''

      },

      rowId: '',
      supplierArr: []

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  created() {
    this.loadSupplier()
    this.loadData()
  },

  methods: {
    loadSupplier() {
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierArr = res.list || []
      })
    },
    onSpecSelect(data) {
      this.searchForm.materialName = data.specName
      this.specName = data.specName
      this.dialogVisible = false
    },
    changeDate(date) {
      if (date && date.length) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    deleteRow(inspectId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.ingredients.deletePaMaterialInspection, {
          inspectId
        }).then(() => {
          this.loadData()
        })
      })
    },

    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.ingredients.selectPaMaterialInspectionByPage, {
          params: params
        })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.specName = ''
      this.onSearch()
    },
    onDownExcel() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.ingredients.exportPaMaterialInspection, {
        ...this.searchForm
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    }

  }
}
</script>
<style lang="scss" scoped></style>
